import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "home" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Outcome = _resolveComponent("Outcome")!
  const _component_Landing = _resolveComponent("Landing")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($setup.sessionFinished)
        ? (_openBlock(), _createBlock(_component_Outcome, { key: 0 }))
        : (_openBlock(), _createBlock(_component_Landing, { key: 1 }))
    ])
  ]))
}